import styled from 'styled-components'

export const SelectPaymentMethodCategoryRadioGroupSectionStyled = styled.div`
  padding: ${(props) => props.theme.space.medium};

  flex-grow: 1;
`
